<div class="header-top" *ngIf="Service =='BookAppointment' ">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-sm-4 col-lg-4 text-center">
                <div class="header-top-item">
                    <div class="header-top-left">
                        <ul>
                            <li>
                                <app-language></app-language>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="signup-area" style="margin: 50px 0px ;">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 pl-0">
                <div class="login-left">
                    <!-- <img src="assets/img/login-bg.jpg" alt="Login"> -->
                </div>
            </div>

            <div *ngIf="Login" class="col-lg-6 ptb-100">
                <div class="signup-item">
                    <!-- <div class="signup-head">
                        <h2>{{'AUTH.LOGIN.TITLE' | translate}}</h2>
                        <p>{{'AUTH.GENERAL.NO_ACCOUNT' | translate}} <a
                                routerLink="/signup">{{'AUTH.GENERAL.SIGNUP_BUTTON' | translate}}</a></p>
                    </div> -->

                    <div class="signup-form">
                        <form class="login-form" [formGroup]="loginForm" (ngSubmit)="submit()">
                            <div class="row">
                                <!-- <div class="col-lg-6">
                                    <div class="form-group">
                                        <input type="text" class="form-control" placeholder="First Name">
                                    </div>
                                </div> -->
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input type="text" class="form-control"
                                            placeholder="{{'AUTH.INPUT.PASSPORTNO' | translate}}"
                                            formControlName="passportNo" autocomplete="off" readonly
                                            onfocus="this.removeAttribute('readonly');">
                                        <div class="text-danger"
                                            *ngIf="controlHasError('required', 'passportNo',loginForm)">
                                            {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                                        </div>
                                        <!-- <input style="margin-top: 20px;" type="checkbox" id="gridCheck"> -->
                                        <!-- <label style="margin: 0px 10px;">{{'AUTH.GENERAL.REMEMBERME' |
                                            translate}}</label> -->
                                    </div>
                                </div>

                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input type="password" class="form-control"
                                            placeholder="{{'AUTH.INPUT.PASSWORD' | translate}}"
                                            formControlName="password">
                                        <div class="text-danger"
                                            *ngIf="controlHasError('required', 'password',loginForm)">
                                            {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="col-lg-6">
                                    <div class="form-group">
                                        <input type="password" class="form-control" placeholder="Confirm Password">
                                    </div>
                                </div> -->
                                <!-- <div class="col-lg-12">
                                    <div class="form-group">
                                        <div class="form-check">
                                            <input style="margin-top: 20px;" type="checkbox" id="gridCheck">
                                            <label style="margin: 0px 10px;">{{'AUTH.GENERAL.REMEMBERME' | translate}}</label>
                                            <label class="form-check-label" for="gridCheck">
                                                {{'AUTH.REGISTER.AGREE' | translate}} <a href="#">{{'AUTH.REGISTER.TERMS' | translate}}</a>
                                            </label>
                                        </div>
                                    </div>
                                </div> -->
                                <!-- <div class="col-lg-12">
                                    <div class="form-group">
                                        <div class="forgot-pass">
                                            <a (click)="ChangeFormForgetPassword()"
                                                style="cursor: pointer;">{{'AUTH.GENERAL.FORGOT_BUTTON' |
                                                translate}}</a>
                                        </div>
                                    </div>
                                </div> -->

                                <ng-container *ngIf="hasError">
                                    <div class="alert alert-danger d-flex align-items-center" role="alert">
                                        <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img"
                                            aria-label="Danger:">
                                            <use xlink:href="#exclamation-triangle-fill" />
                                        </svg>
                                        <div>
                                            {{ ErrorMessage }}
                                        </div>
                                    </div>
                                </ng-container>
                                <div class="col-lg-12">
                                    <div class="text-center">
                                        <button type="submit" class="btn signup-btn">{{'AUTH.LOGIN.BUTTON' |
                                            translate}}</button>
                                        <ng-container *ngIf="isLoading$ | async">
                                            <div class="spinner-border" role="status" style="margin-top: 30px;">
                                                <span class="visually-hidden"></span>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!-- <div *ngIf="ForgetPassword" class="col-lg-6 ptb-100">
                <div class="signup-item">
                    <div class="signup-head">
                        <h2>{{'AUTH.GENERAL.FORGOT_BUTTON' | translate}}</h2>
                    </div>
                    <div class="signup-form">
                        <form class="login-form" [formGroup]="forgetPasswordForm">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input type="text" class="form-control"
                                            placeholder="{{'AUTH.INPUT.PASSPORTNO' | translate}}"
                                            formControlName="PassportNo" autocomplete="off" readonly
                                            onfocus="this.removeAttribute('readonly');">
                                        <div class="text-danger"
                                            *ngIf="controlHasError('required', 'PassportNo',forgetPasswordForm)">
                                            {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input type="number" class="form-control"
                                            placeholder="{{'AUTH.INPUT.PHONENUMBER' | translate}}"
                                            formControlName="Mobile" autocomplete="off" readonly
                                            onfocus="this.removeAttribute('readonly');">
                                        <div class="text-danger"
                                            *ngIf="controlHasError('required', 'Mobile',forgetPasswordForm)">
                                            {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                                        </div>
                                        <div class="text-danger" *ngIf="controlHasError('pattern', 'Mobile',forgetPasswordForm)">
                                            {{ 'AUTH.VALIDATION.MOBILE_VALIDATION'| translate }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="form-group">
                                    <div class="forgot-pass">
                                        <a (click)="ChangeFormLogin()" style="cursor: pointer;">{{'AUTH.LOGIN.BUTTON' |
                                            translate}}</a>
                                    </div>
                                </div>
                            </div>
                            <ng-container *ngIf="hasError">
                                <div class="alert alert-danger d-flex align-items-center" role="alert">
                                    <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img"
                                        aria-label="Danger:">
                                        <use xlink:href="#exclamation-triangle-fill" />
                                    </svg>
                                    <div>
                                        {{ ErrorMessage }}
                                    </div>
                                </div>
                            </ng-container>
                            <div class="col-lg-12">
                                <div class="text-center">
                                    <button type="button" (click)="CheckAccountValid()"
                                        class="btn signup-btn">{{'CONTACTUS.SEND' | translate}}</button>
                                    <ng-container *ngIf="isLoading$ | async">
                                        <div class="spinner-border" role="status" style="margin-top: 30px;">
                                            <span class="visually-hidden"></span>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</div>